import { Injector } from "@angular/core";
import { BaseNode } from "../../BaseNode";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { DateUtil } from "../../../DateUtil";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { AbstractPharmaceuticalProductEntity } from "../../../Data/MedicinalProductData/AbstractPharmaceuticalProductEntity";
import { EntityEnum } from "../../EntityEnum";
import { TreeNodeMedicinalProductsAbstractStrengthFormulation } from "../ListEntity/TreeNodeMedicinalProductsAbstractStrengthFormulation";
import { AutoUploadList } from "../ListEntity/AutoUploadList";
import { environment } from "../../../../../../environments/environment";
import { OnDemandNode } from "../../OnDemandNode";

export class TreeNodeAbstractPharmaceuticalProductEntity extends OnDemandNode {
    disableAutoupload = false;
    cloningNode: boolean = false;
    model: any;
    constructor(injector: Injector, labelTemplate: string, parent: BaseNode, disableAutoupload: boolean, cloningNode: boolean,model: any) {
        super(injector, new AbstractPharmaceuticalProductEntity(injector, model), labelTemplate);
        this.parent = parent;
        this.disableAutoupload = disableAutoupload;
        this.cloningNode = cloningNode;
        this.model = model;
        this.ioc!.get(Art57Section).generateNumColumValue(this);
        if (this.cloningNode) {
            return;
        }
        if (((parent as AutoUploadList).autoUploadEntityName == EntityEnum.abstractPharmaceuticalProduct)||((parent as AutoUploadList).autoUploadEntityName == EntityEnum.abstractPharmaceuticalProductSYM)) {
            this.children?.push(new TreeNodeMedicinalProductsAbstractStrengthFormulation(injector, this.model.pk_scientificproduct, EntityEnum.abstractStrength, this, false, false,false));
            this.children?.push(new TreeNodeMedicinalProductsAbstractStrengthFormulation(injector, this.model.pk_scientificproduct, EntityEnum.abstractFormulation, this, false, false,false));
        } else if ((parent as AutoUploadList).autoUploadEntityName == EntityEnum.abstractStrength) {
            this.children?.push(new TreeNodeMedicinalProductsAbstractStrengthFormulation(injector, this.model.pk_scientificproduct, EntityEnum.abstractStrengthComposition, this, false, false,false));
        } else if ((parent as AutoUploadList).autoUploadEntityName == EntityEnum.abstractFormulation) {
            this.children?.push(new TreeNodeMedicinalProductsAbstractStrengthFormulation(injector, this.model.pk_scientificproduct, EntityEnum.abstractFormulationComposition, this,false,false,false));
        } 
    }

    public getListItem(): any[] {
        return [this.data.model.scientificname,
        this.data.model.scientificcode,
        this.data.model.scientificstrength,
        this.data.model.name_pharmform,
        this.ioc!.get(LookupGetService).retrieveValueFromCache('substancestypes', this.data.model.is_development),
        this.ioc!.get(LookupGetService).retrieveValueFromCache('binaryYesNo', this.data.model.ismanuallydesc),
        this.ioc!.get(LookupGetService).retrieveValueFromCache('binaryYesNo', this.data.model.wasmanuallydesc),
        this.ioc!.get(LookupGetService).retrieveValueFromCache('binaryYesNo', this.data.model.inmanuallydesc),
        DateUtil.getDateTimeFormat(this.data.model.created_stamp),
        this.ioc!.get(LookupGetService).retrieveValueFromCache('pispStatus', this.data.model.status),
        DateUtil.getYesNoDateTimeFormat(this.data.model.stamp_nullif)
        ];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeAbstractPharmaceuticalProductEntity = new TreeNodeAbstractPharmaceuticalProductEntity(
        this.ioc!,
        this.labelTemplate,
        newParent,
        true,
        true,
        this.model
      );
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
      
      clonedNode.cloningNode = false;
      return clonedNode;
    }    

    override getOnDemandEntity() {
        let onDemandEntities = {};
        if (this.children && this.children?.length<3 && 
            this.children[0] instanceof TreeNodeMedicinalProductsAbstractStrengthFormulation) {
            
            const onDemandEntity1 = this.children[0].getOnDemandEntities();
            if (Array.isArray(onDemandEntity1) || Object.keys(onDemandEntity1).length !== 0) {
                onDemandEntities = {...onDemandEntities, ...onDemandEntity1};
            }

            if (this.children.length == 2) {
                const onDemandEntity2 = (this.children[1] as TreeNodeMedicinalProductsAbstractStrengthFormulation).getOnDemandEntities();
                if (Array.isArray(onDemandEntity2) || Object.keys(onDemandEntity2).length !== 0) {
                    onDemandEntities = {...onDemandEntities, ...onDemandEntity2};
                }
            }
            return {...super.getOnDemandEntity(), ...onDemandEntities};
            
        } else {
           return super.getOnDemandEntity();     
        }

    }
}